export const resolvePosterQrDesign = (reference, qrItems = []) => {
  if (!reference?.id) return { qr: null, error: "" };
  const expectedId = `qrd_${String(reference.id).replace(/^qrd_/, "")}`;
  const qr = qrItems.find((item) => item?.designed && item.id === expectedId) || null;
  if (!qr) return { qr: null, error: "MISSING" };
  if (qr.value !== reference.link) return { qr: null, error: "LINK_MISMATCH" };
  return { qr, error: "" };
};

export const isDesignedQrSelection = (mode, selectedId, qrItems = []) =>
  mode === "gallery" && qrItems.some((item) => item?.designed && item.id === selectedId);
